import { Api as ApiNamespace } from './nexus/api';
import { Lib as LibNamespace } from './nexus/lib';
export var Nexus;
(function (Nexus) {
    Nexus.Api = ApiNamespace;
    Nexus.Lib = LibNamespace;
})(Nexus || (Nexus = {}));
